module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAUCAYAAABvVQZ0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgB7ZTBDYQgFETnbyzAEijBDqSULWFLsINtQTuxA+3A2AEd4BA5eADB4MGDL5lAAjwIgS8IYK2t2SimRgYiMiIiUsxirzG5tVXA9/Wn6pkVaVpGU9iETtb53RQyOMzXH9zIK3tlj5K57+Jfu4rNqZDPn9G+35XKBsZgLwAokrFm9WeilOzH+zFI00ZHSoqjRISuXDfIw/AKZtfZANO1pHyOdJjIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/icon-phone.png
// module id = u7LX
// module chunks = 0